import { NavLink } from 'react-router-dom';
import { NAV_ITEMS } from './navItems';
import { useContentAccess } from '../../hooks/useContentAccess';

export default function BottomNav() {
  const { isPremium } = useContentAccess();

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 h-16 bg-white/90 backdrop-blur-md border-t border-gray-100 shadow-[0_-4px_24px_rgba(0,0,0,0.06)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-center justify-around h-full max-w-lg mx-auto px-2">
        {NAV_ITEMS.map(({ to, label, Icon, isPremiumGated }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 min-w-[48px] px-1 py-1 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'text-primary-600'
                  : 'text-gray-400 hover:text-gray-500'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className="relative flex items-center justify-center w-8 h-8 rounded-xl transition-all duration-200">
                  <div
                    className={`absolute inset-0 rounded-xl transition-all duration-200 ${
                      isActive ? 'bg-primary-50' : ''
                    }`}
                  />
                  <Icon
                    size={20}
                    className={`relative z-10 ${isActive ? 'text-primary-600' : 'text-gray-400'}`}
                  />
                  {isPremiumGated && !isPremium && (
                    <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-warm-400 rounded-full border border-white z-20" />
                  )}
                </div>
                <span
                  className={`text-[9px] font-semibold leading-none transition-all duration-200 ${
                    isActive ? 'text-primary-600' : 'text-gray-400'
                  }`}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
